export const idStartFrame = 1;
export const idEndFrame = 1;
